import request from '../Functions/ajax/request'

import { someTime } from '../../../shared/utilities'

import FormsStore from '../../Stores/Forms'

export default async function AdSectionLoader ({ params={ } })
{
	return { page: getAdSection(true, params), params };
}

async function getAdSection (retry=true, params)
{
	let failed = false;

	try
	{
		var { data } = await request('/ad-section/list')
		.post({ id: params.id });

		if (!data?.[0]?._id)
		{
			throw { ERROR_CODE: 'NOT_FOUND', error: 'Section introuvable.' };
		}

		failed = false;
	}
	catch (update)
	{
		if (['DENIED', 'FORBIDDEN'].includes(update.ERROR_CODE))
		{
			throw { code: 401, throw_up: true };
		}

		if (update.ERROR_CODE === 'NOT_FOUND')
		{
			throw { code: 404, throw_up: true };
		}

		if (update.ERROR_CODE || !retry) throw update;

		failed = true;

		await someTime(5000);
	}

	if (failed)
	{
		return await getAdSection(false, params);
	}

	const ad = data[0];


	if (ad)
	{
		FormsStore.update(function (store)
		{
			store['AdSection'] =
			{
				title: ad.title || '',
				start: ad.start || '',
				end: ad.end || '',
				images: ad.images || []
			};

			return store;
		});
	}

	return { ad: data?.[0] };
}